import { ButtonHTMLAttributes, forwardRef } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

const StyledButton = styled.button`
  padding: 0;
  border: none;
  border-bottom: 1px dashed currentColor;
  background: none;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    color: ${({ theme }) => theme.color.mediumGrey};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.color.darkGreen};
    outline-offset: 2px;
  }
`

export type TextLinkButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export const TextLinkButton = forwardRef<
  HTMLButtonElement,
  TextLinkButtonProps
>(({ type = 'button', ...rest }, ref) => (
  <StyledButton type={type} ref={ref} {...rest} />
))
